module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('transition', {
    attrs: {
      "name": "esocial-modal-fade"
    }
  }, [(_vm.parent.showNovoXml) ? _c('div', {
    staticClass: "esocial-modal-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.close($event)
      }
    }
  }, [_c('div', {
    staticClass: "esocial-modal esocial-modal--wide"
  }, [_c('div', {
    staticClass: "esocial-modal__header"
  }, [_c('span', {
    staticClass: "esocial-modal__title"
  }, [_vm._v("Inserir novo XML")]), _vm._v(" "), _c('button', {
    staticClass: "esocial-modal__close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_c('i', {
    staticClass: "fa fa-times"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__body"
  }, [_c('ed-form', {
    attrs: {
      "model": _vm.formData
    }
  }, [_c('ed-input-select', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12",
    attrs: {
      "label": "Selecione um Layout",
      "items": _vm.getTabelas(),
      "required": ""
    },
    model: {
      value: (_vm.formData.layout),
      callback: function($$v) {
        _vm.$set(_vm.formData, "layout", $$v)
      },
      expression: "formData.layout"
    }
  }), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pa-0",
    attrs: {
      "label": "Empresa",
      "name": "id_emp",
      "items": _vm.bind.empresas,
      "loading": _vm.bind.loadingEmpresa,
      "disabled": !_vm.formData.layout,
      "clearable": "",
      "required": "",
      "is-object": ""
    },
    on: {
      "search": _vm.getEmpresa,
      "input": _vm.setEmpresa
    },
    model: {
      value: (_vm.formData.empresa),
      callback: function($$v) {
        _vm.$set(_vm.formData, "empresa", $$v)
      },
      expression: "formData.empresa"
    }
  }), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pa-0",
    attrs: {
      "label": "Trabalhador (a)",
      "name": "id_fun",
      "items": _vm.bind.funcionarios,
      "loading": _vm.bind.loadingFuncionario,
      "disabled": !_vm.formData.id_emp,
      "clearable": "",
      "required": "",
      "is-object": ""
    },
    on: {
      "search": _vm.getFuncionario,
      "input": _vm.setFuncionario
    },
    model: {
      value: (_vm.formData.funcionario),
      callback: function($$v) {
        _vm.$set(_vm.formData, "funcionario", $$v)
      },
      expression: "formData.funcionario"
    }
  }), _vm._v(" "), (_vm.formData.layout == 'S-2240') ? _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 pa-0",
    attrs: {
      "label": "Frente de Trabalho",
      "name": "valor.id_fdt",
      "items": _vm.bind.fdt,
      "loading": _vm.bind.loadingFdt,
      "disabled": !_vm.formData.id_emp,
      "clearable": "",
      "required": ""
    },
    on: {
      "search": _vm.getFdt
    },
    model: {
      value: (_vm.formData.valor.id_fdt),
      callback: function($$v) {
        _vm.$set(_vm.formData.valor, "id_fdt", $$v)
      },
      expression: "formData.valor.id_fdt"
    }
  }) : _vm._e(), _vm._v(" "), _c('ed-input-auto-complete', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pa-0",
    attrs: {
      "label": "Categoria do Trabalhador",
      "info": "Somente se informado no evento de admissão do layout S-2200",
      "items": _vm.bind.categorias,
      "loading": _vm.bind.loadingCategoria,
      "clearable": ""
    },
    on: {
      "search": _vm.getCategoria
    },
    model: {
      value: (_vm.formData.valor.id_esocial_categoria),
      callback: function($$v) {
        _vm.$set(_vm.formData.valor, "id_esocial_categoria", $$v)
      },
      expression: "formData.valor.id_esocial_categoria"
    }
  }), _vm._v(" "), _c('ed-input-text', {
    staticClass: "col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 pa-0",
    attrs: {
      "label": "Mátricula do Trabalhador",
      "info": "Somente se informado no evento de admissão do layout S-2200"
    },
    model: {
      value: (_vm.formData.valor.matricula),
      callback: function($$v) {
        _vm.$set(_vm.formData.valor, "matricula", $$v)
      },
      expression: "formData.valor.matricula"
    }
  }), _vm._v(" "), (_vm.formData.layout == 'S-2220') ? _c('s2220', {
    attrs: {
      "formData": _vm.formData.valor,
      "parent": this,
      "avulso": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.formData.layout == 'S-2240' && _vm.formData.id_emp && _vm.formData.id_fun && _vm.formData.valor.id_fdt) ? _c('s2240', {
    attrs: {
      "formData": _vm.formData.valor,
      "parent": this,
      "avulso": 1
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "esocial-modal__footer"
  }, [_c('button', {
    staticClass: "esocial-search__btn esocial-search__btn--filter",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.salvar
    }
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Salvar\n          ")])])])]) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b0015b7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/web/esocial/s0000.vue
// module id = 1537
// module chunks = 45